var s={postCosmosTicket:"/api/cosmos/ticket",searchCaseById:"/api/cosmos/search-case-by-id?searchText=#{searchText}"};export{s as API_URLS};
//# sourceMappingURL=constants.js.map
